import React from 'react';

// Exit control for the intake forms — returns to the page the form was opened
// from rather than dead-ending the user on a submitted form.
const CloseButton = ({ onClick, label = 'Close and go back' }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full text-2xl leading-none text-gray-500 hover:text-black hover:bg-gray-100 transition-colors"
  >
    &times;
  </button>
);

export default CloseButton;
